import React from "react";
import {
  TableRow,
  TableCell,
  Box,
  Typography,
  Avatar,
  Button,
  Tooltip
} from "@mui/material";
import CustomCheckbox from "./CustomCheckbox";
import AuditLogActivityBar from "./AuditLogActivityBar";

const cellStyle = {
  padding: '10px 16px',
};

const getInitials = (name) => {
  const names = name.split(" ");
  return names.map(n => n[0]).join("").toUpperCase();
};

const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `hsl(${hash % 360}, 60%, 60%)`;
  return color;
};


const AuditLogRow = ({ row, isSelected, onSelectToggle, }) => {
  return (
    <TableRow sx={{
      '&:hover': { boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' },
      backgroundColor: '#fff',
      borderRadius: '10px',
      transition: 'box-shadow 0.3s ease',
    }}>
      <TableCell sx={{
        ...cellStyle,
        border: 'none',
        minWidth: '32px',
        maxWidth: '32px',
        borderRadius: '10px 0 0 10px',
      }}>
        <CustomCheckbox checked={isSelected} onChange={onSelectToggle} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        {row.id}
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'left' }}>
        {(row.authoravatar || row.authorName || row.authorRole) ? (
          <Box display="flex" alignItems="center" gap={1}>
            <Avatar
              src={row.authoravatar || undefined}
              sx={{
                width: '40px',
                height: '40px',
                fontSize: '13px',
                backgroundColor: !row.authoravatar ? stringToColor(row.authorName) : 'transparent',
                color: !row.authoravatar ? '#fff' : 'inherit',
              }}
            >
              {!row.authoravatar && getInitials(row.authorName)}
            </Avatar>
            <Box>
              <Typography fontWeight="bold" sx={{ whiteSpace: 'nowrap' }}>
                {row.authorName}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ whiteSpace: 'nowrap' }}
              >
                {row.authorRole}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">—</Typography>
        )}
      </TableCell>


      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.time}
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.action === "Added" ? (
          <Button
            sx={{
              background: '#EBF8EE', // light green
              color: '#38B758',      // dark green text
              fontSize: '13px',
              textTransform: 'capitalize',
              borderRadius: '50px',
              px: 3,
            }}
          >
            Added
          </Button>
        ) : row.action === "Invite" ? (
          <Button
            sx={{
              background: '#EEEBFD', // light red
              color: '#5932EA',      // dark red text
              fontSize: '13px',
              textTransform: 'capitalize',
              borderRadius: '50px',
              px: 3,
            }}
          >
            Accepted invite
          </Button>
        ) : (
          <Button
            sx={{
              background: '#FFF5E5', // light blue
              color: '#FF9A00',      // dark blue text
              fontSize: '13px',
              textTransform: 'capitalize',
              borderRadius: '50px',
              px: 3,
            }}
          >
            Created
          </Button>
        )}
      </TableCell>



      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'left' }}>
        {row.object}
      </TableCell>
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'left' }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Avatar src={row.memberavatar} sx={{ width: '40px', height: '40px', fontSize: '13px' }} />
          <Box>
            <Typography fontWeight="bold" sx={{ whiteSpace: 'nowrap' }}>{row.memberName}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
              {row.memberRole}
            </Typography>
          </Box>
        </Box>
      </TableCell>

      <TableCell sx={{
        ...cellStyle,
        border: 'none',
        textAlign: 'center',
        borderRadius: '0px 10px 10px 0px'
      }}>
        <Tooltip title={row.details || ''} arrow placement="top">
          <Typography
            sx={{
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: 220,
              textAlign: 'right',
              fontSize: '13px',
              marginLeft: 'auto',
            }}
          >
            {row.details?.split(' ').slice(0, 5).join(' ') + (row.details?.split(' ').length > 5 ? '...' : '')}
          </Typography>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default AuditLogRow;
